import { render, staticRenderFns } from "./GalleryMobile.vue?vue&type=template&id=d829035a&scoped=true&"
import script from "./GalleryMobile.vue?vue&type=script&lang=js&"
export * from "./GalleryMobile.vue?vue&type=script&lang=js&"
import style0 from "./GalleryMobile.vue?vue&type=style&index=0&id=d829035a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d829035a",
  null
  
)

export default component.exports